<template>
  <NewsListPage
    title="行业新闻"
    category-name="行业新闻"
    category-path="industry"
    root-class="industry-news"
    :page-size="6"
  />
</template>

<script>
  import NewsListPage from '../components/NewsListPage.vue'

  export default {
    name: 'IndustryNews',
    components: { NewsListPage }
  }
</script>